import { useSelector } from 'react-redux'
import styled from 'styled-components'

import { AuthLayout } from '../../components/AuthLayout'
import { PageBody } from '../../components/PageBody'
import { NAS_URL } from '../../config/env'
import { selectUser } from '../../store/user'
import { isEqual } from '../../util/isEqual'

const Iframe = styled.iframe`
  border: 0px;
`

const Container = styled.div`
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  flex-flow: column nowrap;
`

const StyledPageBody = styled(PageBody)`
  overflow: auto;
  min-height: 0px;
  flex: 1 1 auto;
`

export function Appointments(): JSX.Element {
  const user = useSelector(selectUser, isEqual)
  const nasUrl = user ? `${NAS_URL}/auth/navtrac?token=${user.token}` : ''
  return (
    <AuthLayout>
      <StyledPageBody>
        <Container>
          <Iframe src={nasUrl} height="100%" width="100%" />
        </Container>
      </StyledPageBody>
    </AuthLayout>
  )
}
